import axios from '@axios'
import axiosRu from '@axios-ru'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // Вариант fetchMovies с AbortSignal: таблица отменяет устаревший запрос, когда уходит новый
    fetchMoviesCancellable(ctx, {params, signal}) {
      return axiosRu.get('/movie', {params, signal})
    },
    fetchMovieListOptions() {
      return axiosRu.get('/movie/list-options')
    },
    fetchMovie(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createMovie(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMovie(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieDetails(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1&themes=1&with_lists=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieClusters() {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/clusters')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    recalculateMovieDifficulty(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/recalculate-difficulty`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMovieClusters(ctx, {id, clusters}) {
      return new Promise((resolve, reject) => {
        // Через основной (не-RU) хост, как синк с Notion: бэкенд зеркалирует кластеры в Notion API
        axios
          .patch(`/movie/${id}/clusters`, {clusters})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieSequels(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/sequels`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieFranchises(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/franchises`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieSeasons(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/seasons`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieVideos(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/videos`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieAwards(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/awards`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieKpExtras(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/load-kp-extras`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    syncMovieNotion(ctx, {id}) {
      return new Promise((resolve, reject) => {
        // Через основной (не-RU) хост, как синк артистов: бэкенд ходит в Notion API
        axios
          .post(`/movie/${id}/sync-notion`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addMovieExternalId(ctx, {id, url}) {
      return new Promise((resolve, reject) => {
        // Через основной (не-RU) хост: TMDb/IMDb-зеркало и kp_dev ходят с основного хоста, как постеры
        axios
          .post(`/movie/${id}/externals`, {url})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchMovieExternalId(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/movie/${id}/externals/${source}/search`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteMovieExternalId(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/movie/${id}/externals/${source}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchFranchises(ctx, {query}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/franchise/search', {params: {query}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFranchise(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/franchise/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createFranchise(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post('/franchise', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFranchise(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .patch(`/franchise/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFranchise(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/franchise/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    attachFranchiseMovie(ctx, {franchiseId, movie_id, part_number}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/franchise/${franchiseId}/movies`, {movie_id, part_number})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFranchiseMovie(ctx, {franchiseId, movieId, part_number}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .patch(`/franchise/${franchiseId}/movies/${movieId}`, {part_number})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    detachFranchiseMovie(ctx, {franchiseId, movieId}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/franchise/${franchiseId}/movies/${movieId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchRatingHistory(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/rating-history`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieFromKPDev(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/import-from-kp/${id}?with_staff=1&themes=1&api=kp-dev`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadStaffFromKP(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/load-staff/${id}?with_staff=1&themes=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieWithStaff(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}?with_staff=1`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFrames(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/frames`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    toggleFrame(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${movie_id}/frame/${id}/toggle`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    previewFrames(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/frames/preview`, {params: {source}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadFrames(ctx, {id, frames}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/frames/download`, {frames})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFrame(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${movie_id}/frame/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviePosters(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/posters`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    previewMoviePosters(ctx, {id, source}) {
      return new Promise((resolve, reject) => {
        // Подбор всегда через основной (не-RU) хост: TMDb заблокирован из RU, остальные источники оттуда тоже доступны
        axios
          .get(`/movie/${id}/posters/preview`, {params: {source}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addMoviePosters(ctx, {id, source, type, posters}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/posters/add`, {source, type, posters})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadMoviePoster(ctx, {id, formData}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/posters`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadMoviePoster(ctx, {id, posterId, source}) {
      return new Promise((resolve, reject) => {
        // Через основной хост при TMDb (заблокирован из RU) и Google (произвольные CDN,
        // часть режет RU-IP — например imgur): скачивание внешнего url идёт бэкендом
        const client = ['tmdb', 'google'].includes(source) ? axios : axiosRu
        client
          .post(`/movie/${id}/poster/${posterId}/download`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMoviePoster(ctx, {id, posterId, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/poster/${posterId}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteMoviePoster(ctx, {id, posterId}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${id}/poster/${posterId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesPremiers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/premiers', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesTop(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/movie/top', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMoviesFilter(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/filter', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchMovies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/search', {params: queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePerson(ctx, {id, data}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/person/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieMedia(ctx, {id, category}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/media`, {params: {category}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadMovieMedia(ctx, {id, formData}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/media`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMovieMedia(ctx, {movie_id, id, title}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${movie_id}/media/${id}`, {title})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteMovieMedia(ctx, {movie_id, id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${movie_id}/media/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchChannels() {
      return new Promise((resolve, reject) => {
        axiosRu
          .get('/movie/channels')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMovieChannels(ctx, {id}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/channels`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMovieChannels(ctx, {id, channels}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .patch(`/movie/${id}/channels`, {channels})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadMovieChannelsFromTmdb(ctx, {id}) {
      return new Promise((resolve, reject) => {
        // Через основной хост (не axiosRu): бэкенд ходит в TMDb, а он заблокирован из RU
        axios
          .post(`/movie/${id}/channels/load-from-tmdb`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    extractTrailerAudio(ctx, {movieId, videoId, site}) {
      return new Promise((resolve, reject) => {
        // YouTube — через основной (не-RU) хост: yt-dlp с RU работает только через прокси.
        // Виджет КП — наоборот, только с RU: strm.yandex.ru не отдаёт поток не-RU IP
        const client = site === 'YOUTUBE' ? axios : axiosRu
        client
          .post(`/movie/${movieId}/videos/${videoId}/extract-audio`, null, {timeout: 180000})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTrailerTmpAudio(ctx, {movieId, tmpPath}) {
      return new Promise((resolve, reject) => {
        // Blob через бэкенд: напрямую с S3 браузер mp3 не отдаст (бакет без CORS-заголовков)
        axiosRu
          .get(`/movie/${movieId}/media/tmp-audio`, {
            params: {tmp_path: tmpPath},
            responseType: 'blob',
            timeout: 120000,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    saveTrailerAudioFromVideo(ctx, {movieId, tmpPath, start, end, title, category}) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${movieId}/media/from-video`, {
            tmp_path: tmpPath,
            start,
            end,
            title,
            category,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    searchYoutubeVideos(ctx, {movieId, query}) {
      return new Promise((resolve, reject) => {
        // Через основной (не-RU) хост: YouTube с RU-сервера недоступен без прокси.
        // yt-dlp тянет полные метаданные каждого найденного видео — запрос долгий
        axios
          .get(`/movie/${movieId}/youtube-search`, {params: {query}, timeout: 120000})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    extractYoutubeAudio(ctx, {movieId, videoId}) {
      return new Promise((resolve, reject) => {
        // Через основной (не-RU) хост: YouTube с RU-сервера недоступен без прокси
        axios
          .post(`/movie/${movieId}/youtube-extract-audio`, {video_id: videoId}, {timeout: 180000})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchMovieSoundtracks(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/soundtracks`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // Soundtrakd и MusicBrainz блокируются из РФ — только основной хост.
    previewMovieSoundtracks(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        const instance = queryParams.source === 'yandex' ? axiosRu : axios
        instance
          .get(`/movie/${id}/soundtracks/preview`, { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // Яндекс доступен только с ru-хоста.
    fetchYandexSoundtrackAlbums(ctx, { id, query }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/soundtracks/yandex-albums`, { params: { query } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchMusicbrainzGroups(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/movie/${id}/soundtracks/musicbrainz-groups`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addMovieSoundtracks(ctx, { id, source, items }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtracks/add`, { source, items })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    createMovieSoundtrack(ctx, { id, payload }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtracks`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    updateMovieSoundtrack(ctx, { id, soundtrackId, payload }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtrack/${soundtrackId}`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    matchMovieSoundtrack(ctx, { id, soundtrackId }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtrack/${soundtrackId}/match`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    uploadMovieSoundtrackFile(ctx, { id, soundtrackId, file }) {
      const formData = new FormData()
      formData.append('file', file)

      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtrack/${soundtrackId}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // ВК и Яндекс работают только с ru-хоста.
    searchMovieSoundtrackAudio(ctx, { id, soundtrackId, source }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .get(`/movie/${id}/soundtrack/${soundtrackId}/search`, { params: { source } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    downloadMovieSoundtrackAudio(ctx, { id, soundtrackId, source, externalId }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .post(`/movie/${id}/soundtrack/${soundtrackId}/download`, { source, external_id: externalId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteMovieSoundtrackFile(ctx, { id, soundtrackId }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${id}/soundtrack/${soundtrackId}/file`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteMovieSoundtrack(ctx, { id, soundtrackId }) {
      return new Promise((resolve, reject) => {
        axiosRu
          .delete(`/movie/${id}/soundtrack/${soundtrackId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
